import * as React from 'react';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Stack from '@mui/material/Stack';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import {useLocation} from 'react-router-dom';
import { useNavigate} from "react-router-dom"
import Nav from 'react-bootstrap/Nav';
import axios  from 'axios';
import baseUrl from '../../../services/api';
export default function MenuListComposition() {
  const navigate = useNavigate()
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const location = useLocation();
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleCloseLogout = (event) => {
    try{
      axios
      .get(`${baseUrl}/logout`)
      
      .then((response) => 
      console.log(response.data.message) 
      )     
      .catch(err => {
        console.error(err);
        
      }); 
      event.preventDefaulte();
    } catch (error) {
      if(error.message === 'Network Error'){
          alert('no internet connection');
      }
  }
     navigate('/');
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };
  const handleForm = (event) => {
    navigate('/survey1');
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }


    setOpen(false);
  };
  const handleClose = (event) => {

    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }


    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <Stack direction="row" spacing={2}>
      
      <div>
        <Nav.Link
          ref={anchorRef}
          id="composition-button"
          aria-controls={open ? 'composition-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
        Settings  
        </Nav.Link>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-start"
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === 'bottom-start' ? 'left top' : 'left bottom',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                    onKeyDown={handleListKeyDown}
                  >
                  
                    <MenuItem>Update profile</MenuItem>
                    <br></br>
                    <MenuItem onClick={handleCloseLogout}>Logout</MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </Stack>
  );
}